// removed by extract-text-webpack-plugin
module.exports = {"toast":"toast__toast___4MVIt","success":"toast__success___2hFJl","error":"toast__error___2YCEA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/toast/toast.scss
// module id = 661
// module chunks = 0